import { ActivitiesTabContent } from "@/entities/activities-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsActivitiesRouteV2: RouteProps = {
  path: appRouterPaths.contacts.activities,
  element: <ActivitiesTabContent />,
};
